<sd-accordion-group [closeOthers]="true" [hideOthers]="false">
  @for (category of categories; track category.title) {
    <sd-accordion
      [brand]="brand"
      [theme]="themesTextEnum.brandLight"
      [title]="category?.title"
      [titleLevel]="titleLevelCategory"
      [isNested]="true"
      iconNameOpened="icon-arrow-up"
      iconNameClosed="icon-arrow-down"
      [iconPos]="iconPos"
      [iconSize]="iconSize"
      (toggled)="onClickCategory($event, category?.title)"
    >
      <sd-accordion-group [closeOthers]="true" [hideOthers]="false">
        @for (question of category.questions; track question) {
          <sd-accordion
            #faqAccordion
            [brand]="brand"
            [theme]="themesTextEnum.brandLight"
            [title]="question?.question"
            titleCustomClass="brand--h5"
            [titleLevel]="(titleLevelCategory !== 6) ? (titleLevelCategory + 1) : titleLevelCategory"
            iconNameOpened="icon-arrow-up"
            iconNameClosed="icon-arrow-down"
            [iconPos]="iconPos"
            [iconSize]="iconSize"
          >
            @if (faqAccordion.isOpened) {
              <sd-html innerClass="c__text is-body-s is-wysiwyg" [html]="question?.answer" tag="div" />
            }
            @if (hasForm) {
              <div class="c__useful-answer">
                @if (!answerSent[question?.id]) {
                  <form [formGroup]="formUsefulAnswers">
                    <p class="is-bold is-body-s">
                      {{'faq.usefulAnswer' | translate}}
                    </p>
                    <div class="c__answers-container {{(formUsefulAnswers.value['formAnswer' + question?.id]?.value === false || isMobile$) ? 'c__answers-container-block' : 'd-flex'}}">
                      <sd-form radio-group-inline
                        class="c__btn-group has-margin-bottom-m"
                        [formControlName]="'formAnswer' + question?.id"
                        nameField="usefullAnswer"
                        [labelHidden]="true"
                        [labelTitle]="'faq.usefullAnswer' | translate"
                        [items]="answersRadio"
                      />
                      @if (formUsefulAnswers.value['formAnswer' + question?.id]?.value === false) {
                        <div class="c__reasons">
                          <p class="is-bold is-body-s">{{'faq.why' | translate}}</p>
                          <sd-form radio-group-inline
                            class="c__btn-group"
                            [formControlName]="'formAnswerReason' + question?.id"
                            nameField="answerReason"
                            [labelHidden]="true"
                            [labelTitle]="'faq.why' | translate"
                            [items]="answerReasons"
                          />
                        </div>
                      }
                      <button sd-button
                        type="submit"
                        class="c__submit"
                        [brand]="brand"
                        [disabled]="!(formUsefulAnswers?.value['formAnswer' + question?.id]?.value || (formUsefulAnswers?.value['formAnswerReason' + question?.id]?.value || formUsefulAnswers?.value['formAnswerReason' + question?.id]?.value === 0))"
                        [isSmall]="true"
                        (click)="onSubmit($event, question.id)"
                      >
                        <span class="is-bold">
                          {{'faq.send' | translate}}
                        </span>
                      </button>
                      @if (hasContactButton && formUsefulAnswers?.value['formAnswer' + question?.id]?.value === false) {
                        <a sd-button
                          type="submit"
                          class="c__contact"
                          [brand]="brand"
                          [routerLink]="contactLink"
                          [isSmall]="true"
                          [isSecondary]="true"
                        >
                          <span class="is-bold">
                            {{'faq.contact' | translate}}
                          </span>
                        </a>
                      }
                    </div>
                  </form>
                }
                @if (answerSent[question?.id]) {
                  <div>
                    <p class="is-body-s">{{'faq.thanks' | translate}}</p>
                  </div>
                }
              </div>
            }
          </sd-accordion>
        }
      </sd-accordion-group>
    </sd-accordion>
  }
</sd-accordion-group>
